import React, { useEffect, useState } from "react";
import axios from "axios";

import { Container, Typography, Box } from "@mui/material";

import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button
} from "@mui/material";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import ScrollTopButton from "../../components/ScrollTopButton";

const Showscopus = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3001/api/";
  } else {
    xURL = "https://sau.rihes.cmu.ac.th/api/";
  }

  const [xNumpaper, _xNumpaper] = useState();

  const [datasource, _datasource] = useState([]);

  useEffect(() => {
    findScopus();
  }, []);

  const findScopus = () => {
    axios
      .get(xURL + "find_scopus")
      .then(result => {
        ShowScopus(result.data);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const ShowScopus = zdata => {
    const Tb1 = [];
    let xnum = 0;

    zdata.forEach((i, idx) => {
      Tb1.push({
        title: i.title,
        year: i.year,
        journal: i.journal_name,
        sjr_q: i.sjr_q,
        link: i.link
      });
      xnum = xnum + 1;
    });

    _xNumpaper(xnum);

    _datasource(Tb1);
  };

  return (
    <React.Fragment>
      <Navbar />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh" // ทำให้สูงเท่าหน้าจอ
        }}
      >
        <Container sx={{ textAlign: "center", maxWidth: "md" }}>
          <Typography
            gutterBottom
            sx={{
              mt: 18,
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              background: "linear-gradient(90deg, #3F51B5, #00BCD4)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
              textShadow: "1px 1px 2px rgba(0,0,0,0.08)",
              letterSpacing: "0.8px",
              lineHeight: 1.4
            }}
          >
            ผลงานตีพิมพ์
          </Typography>

          {/* 🧾 Card เพิ่มหัวข้อ */}
          <Card
            elevation={3}
            sx={{
              width: "100%",
              margin: "auto",
              mt: 4,
              padding: 2,
              borderRadius: 3,
              textAlign: "center",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)"
            }}
          >
            <Typography
              variant="subtitle1"
              component="div"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                backgroundColor: "#511D43",
                paddingY: 1,
                paddingX: 2,
                borderRadius: 2,
                color: "#fff",
                fontSize: "0.95rem",
                textAlign: "left"
              }}
            >
              จำนวนผลงานตีพิมพ์ใน SCOPUS จำนวน {xNumpaper} เรื่อง
            </Typography>

            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table>
                <TableHead sx={{ backgroundColor: "#0ABAB5", height: 50 }}>
                  <TableRow>
                    <TableCell
                      align="center"
                      sx={{ color: "#ffffff", fontWeight: "bold" }}
                    >
                      ลำดับที่
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#ffffff", fontWeight: "bold", width: 450 }}
                    >
                      ชื่อเรื่อง
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#ffffff", fontWeight: "bold" }}
                    >
                      ปี
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#ffffff", fontWeight: "bold", width: 250 }}
                    >
                      ชื่อวารสาร
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ color: "#ffffff", fontWeight: "bold" }}
                    >
                      SJR (Q)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {datasource.map((row, index) =>
                    <TableRow key={index}>
                      <TableCell align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">
                        <Typography
                          variant="body2"
                          sx={{ color: "#1976d2", cursor: "pointer" }}
                          onClick={() => {
                            window.open(row.link, "_blank");
                          }}
                        >
                          {row.title}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        {row.year}
                      </TableCell>
                      <TableCell align="left">
                        {row.journal}
                      </TableCell>
                      <TableCell align="center">
                        {row.sjr_q}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Container>

        <ScrollTopButton />
      </Box>

      <div style={{ height: "100px" }} />
      <Footer />
    </React.Fragment>
  );
};

export default Showscopus;
